export default "__VITE_ASSET__74f146ff__"